import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './mohave.css';

// Импорт изображений
import headerLogo from '../assets/MAIN/header_logo.png';
import mohaveBack from '../assets/mohave/mhv back.png';
import topImage from '../assets/mohave/Top.png';
import photot from '../assets/mohave/photot.png';
import archi from '../assets/mohave/archi.png';
import carImage from '../assets/mohave/car.png';
import resumePDF from '../assets/MAIN/Dzhevelik_CV.pdf';

// Галерея изображений
import gallery1 from '../assets/mohave/gallery/1.png';
import gallery2 from '../assets/mohave/gallery/2.png';
import gallery3 from '../assets/mohave/gallery/3.png';
import gallery4 from '../assets/mohave/gallery/4.png';
import gallery5 from '../assets/mohave/gallery/5.png';
import gallery6 from '../assets/mohave/gallery/6.png';
import gallery7 from '../assets/mohave/gallery/7.png';

import Footer from './Footer';

function Mohave() {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // Функция скачивания резюме
  const downloadResume = () => {
    const link = document.createElement('a');
    link.href = resumePDF;
    link.download = 'Dzhevelik_CV.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  const galleryImages = [
    { src: gallery1, title: 'Status Control' },
    { src: gallery2, title: 'My Car' },
    { src: gallery3, title: 'Service History' },
    { src: gallery4, title: 'Record Details' },
    { src: gallery5, title: 'Maintenance Details' },
    { src: gallery6, title: 'Your Account' },
    { src: gallery7, title: 'ELM Device' }
  ];

  // Создаем массив для отображения (показываем все элементы по кругу)
  const createGalleryArray = () => {
    const multiplier = 3; // Троим массив для плавной прокрутки
    const result = [];
    for (let i = 0; i < galleryImages.length * multiplier; i++) {
      result.push(galleryImages[i % galleryImages.length]);
    }
    return result;
  };

  const displayImages = createGalleryArray();

  // Автоматическое движение галереи
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;
        // Если дошли до конца второй части, сбрасываем на начало второй части
        if (nextIndex >= galleryImages.length * 2) {
          return galleryImages.length;
        }
        return nextIndex;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [galleryImages.length]);

  // Сброс позиции без анимации
  useEffect(() => {
    if (currentIndex >= galleryImages.length * 2) {
      const timeout = setTimeout(() => {
        setCurrentIndex(galleryImages.length);
      }, 0);
      return () => clearTimeout(timeout);
    }
    if (currentIndex < galleryImages.length) {
      const timeout = setTimeout(() => {
        setCurrentIndex(galleryImages.length + currentIndex);
      }, 0);
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, galleryImages.length]);

  const handleImageClick = (clickedIndex) => {
    const relativeIndex = clickedIndex - currentIndex;
    
    if (relativeIndex < 0) {
      // Клик слева - идем назад
      setCurrentIndex(prev => Math.max(prev - 1, galleryImages.length));
    } else if (relativeIndex > 0) {
      // Клик справа - идем вперед
      setCurrentIndex(prev => Math.min(prev + 1, galleryImages.length * 2 - 1));
    }
  };

  // Расчет сдвига для показа 4.5 элементов
  const itemWidth = 100 / 4.5;
  const translateX = -currentIndex * itemWidth;

  return (
    <div className="App mohave-page">
      <main className="App-main">
        <div className="mohave-content">
{/* Top Image Section - Full Width with Text Overlay */}
<section className="mohave-top-section-fullwidth">
  <img src={topImage} alt="Top" className="mohave-top-image-full" />
  <div className="mohave-top-text-overlay">
    <h1 className="mohave-top-main-title">MOHAVE.PRO</h1>
    <p className="mohave-top-subtitle">Mobile-app</p>
  </div>
</section>
          {/* Description Section */}
          <section className="mohave-description-section">
            <div className="mohave-description-content">
              <div className="mohave-description-left">
                <h2 className="mohave-description-title">DESCRIPTION</h2>
              </div>
              <div className="mohave-description-right">
                <p className="mohave-description-text selectable">
                  MOHAVE PRO is a mobile app for automotive community that combines social networking with vehicle maintenance management. The design addresses the challenge of creating a unified ecosystem through thoughtful information architecture that ensures comfortable usage and quick access to needed functions without unnecessary navigation steps.
                </p>
                <div className="mohave-info-grid">
                  <div className="mohave-info-column">
                    <div className="mohave-info-header">CLIENT</div>
                    <div className="mohave-info-value">MOHAVE PRO</div>
                  </div>
                  <div className="mohave-info-column">
                    <div className="mohave-info-header">MY ROLE</div>
                    <div className="mohave-info-value">DESIGNER</div>
                  </div>
                  <div className="mohave-info-column">
                    <div className="mohave-info-header">DATE</div>
                    <div className="mohave-info-value">FEB 2025</div>
                  </div>
                  <div className="mohave-info-column">
                    <div className="mohave-info-header">TIME</div>
                    <div className="mohave-info-value">MONTH</div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Mobile App Title */}
          <section className="mohave-mobile-app-section">
            <h1 className="mohave-mobile-app-title">
              <span className="mohave-mobile-text">MOBILE</span>
              <span className="mohave-app-dash">-</span>
              <span className="mohave-app-text">APP</span>
            </h1>
          </section>

          {/* System Development Section */}
          <section className="mohave-system-section">
            <div className="mohave-system-content">
              <div className="mohave-system-left">
                <h2 className="mohave-system-title">SYSTEM DEVELOPMENT</h2>
              </div>
              <div className="mohave-system-right">
                <p className="mohave-system-text selectable">
                  Design work involved creating a scalable system for product evolution from MVP to full-featured platform. Developed modular interface architecture allowing organic integration of new functionality at each stage – from basic vehicle monitoring to complex social and commercial tools for club community.
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* Photo Section - Max Width 1400px */}
        <section className="mohave-photo-section">
          <img src={photot} alt="Photo" className="mohave-photo" />
        </section>

        <div className="mohave-content" style={{backgroundImage: `url(${mohaveBack})`}}>
          {/* Referral System Section */}
          <section className="mohave-referral-section">
            <div className="mohave-referral-content">
              <div className="mohave-referral-header">
                <h2 className="mohave-referral-title">REFERRAL SYSTEM</h2>
                <div className="mohave-referral-text">
                  <p className="selectable">
                    Managing your car with Mohave.Pro is simple and convenient. Track system status, maintain service history and access important information with just a few taps. Take a look at the main screens:
                  </p>
                </div>
              </div>
              
              {/* Gallery */}
              <div className="mohave-gallery">
                <div className="mohave-gallery-container">
                  <div 
                    className="mohave-gallery-track"
                    style={{ transform: `translateX(${translateX}%)` }}
                  >
                    {displayImages.map((image, index) => (
                      <div 
                        key={index} 
                        className="mohave-gallery-item"
                        onClick={() => handleImageClick(index)}
                      >
                        <img 
                          src={image.src} 
                          alt={image.title}
                        />
                        <p className="mohave-gallery-title">{image.title}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Social Media Title */}
          <section className="mohave-social-title-section">
            <h1 className="mohave-social-title">SOCIAL MEDIA</h1>
          </section>
        </div>

        {/* Car Image Section - Full Width */}
        <section className="mohave-car-section">
          <img src={carImage} alt="Car" className="mohave-car-image" />
        </section>

        <div className="mohave-content" style={{backgroundImage: `url(${mohaveBack})`}}>
          {/* Final Text Section */}
          <section className="mohave-final-section">
            <div className="mohave-final-content">
              <div className="mohave-final-left">
                <p className="mohave-final-text selectable">
                  Managing your car with Mohave.Pro is simple and convenient. Track system status, maintain service history and access important information with just a few taps. Take a look at the main screens:
                </p>
              </div>
              <div className="mohave-final-right"></div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Mohave;